const PATH = "/api/v1/zoworld";

const ENDPOINTS = {
  JOBS: "/jobs/",
};

export type ZostelJobsEndpoints = keyof typeof ENDPOINTS;
export const ZostelJobsCollection = { PATH, ENDPOINTS };
